import type { TaxCategory } from "@fiscalo/shared-types";

export const TAX_RATE_BY_CATEGORY: Partial<Record<TaxCategory, number>> = {
  exempt: 0,
  vat_basic: 0.22,
  vat_minimum: 0.1,
  vat_other: 0,
  other: 0,
  export: 0,
};

/**
 * Tax for a line at an explicit rate.
 *
 * The category-keyed variant below cannot serve the régimen especial rates:
 * both 2,2% and 2,75% are category `vat_other`, whose entry in the map is 0.
 * Anything that knows its rate should use this.
 */
export function getLineTaxAmountAtRate(
  rate: number,
  quantity: number,
  unitPrice: number
): number {
  const subtotal = quantity * unitPrice;
  return Math.round(subtotal * rate * 100) / 100;
}

export function getLineTaxAmount(
  category: TaxCategory,
  quantity: number,
  unitPrice: number
): number {
  const rate = TAX_RATE_BY_CATEGORY[category] ?? 0;
  const subtotal = quantity * unitPrice;
  return Math.round(subtotal * rate * 100) / 100;
}

export function isPriceWithoutVat(category: TaxCategory): boolean {
  return (TAX_RATE_BY_CATEGORY[category] ?? 0) === 0;
}
